import { Skeleton, Stack } from "@mui/material";
import { FormSection } from "Components/Shared/FormSection";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES =
  Resources.Hunter.Merchants.CompleteRegistration.SendAccess;

export const SendAccessSkeleton = () => {
  const { t } = useResource();

  return (
    <Stack gap={3}>
      <FormSection legend={t(COMPONENT_RESOURCES.Title)}>
        <Skeleton variant="rectangular" height={120} />
      </FormSection>
      <Skeleton variant="rectangular" height={56} />
      <Skeleton variant="rectangular" height={42} />
    </Stack>
  );
};
